// Shared utils & constants for Calendar V3 sub-components.
// Extracted from CalendarV3.jsx as part of tech-debt refactor.
//
// COLOUR SYSTEM (finalised Feb 2026):
//   OPEN              → Blue
//   PARTIALLY_FILLED  → Amber
//   ASSIGNED          → Green (emerald)
//   CONFIRMED         → Green (emerald)
//   IN_PROGRESS       → Purple (violet)
//   COMPLETED         → Grey (slate)
//   INVOICED          → Teal
//   CANCELLED         → Stone (kept neutral — red is reserved for NO_SHOW)
//   NO_SHOW           → Red
//   DRAFT             → Slate (fallback)
// No logic changed — purely visual.

export const STATUS_COLORS = {
  DRAFT:            { bg: 'bg-slate-100 border-slate-300',  text: 'text-slate-700',   dot: 'bg-slate-400' },
  OPEN:             { bg: 'bg-blue-50 border-blue-300',     text: 'text-blue-700',    dot: 'bg-blue-500' },
  PARTIALLY_FILLED: { bg: 'bg-amber-50 border-amber-300',   text: 'text-amber-700',   dot: 'bg-amber-500' },
  ASSIGNED:         { bg: 'bg-emerald-50 border-emerald-300', text: 'text-emerald-700', dot: 'bg-emerald-500' },
  CONFIRMED:        { bg: 'bg-emerald-50 border-emerald-300', text: 'text-emerald-700', dot: 'bg-emerald-500' },
  IN_PROGRESS:      { bg: 'bg-violet-50 border-violet-300', text: 'text-violet-700',  dot: 'bg-violet-500' },
  COMPLETED:        { bg: 'bg-slate-100 border-slate-300',  text: 'text-slate-700',   dot: 'bg-slate-500' },
  INVOICED:         { bg: 'bg-teal-50 border-teal-400',     text: 'text-teal-700',    dot: 'bg-teal-600' },
  CANCELLED:        { bg: 'bg-stone-100 border-stone-300',  text: 'text-stone-600',   dot: 'bg-stone-400' },
  NO_SHOW:          { bg: 'bg-red-50 border-red-400',       text: 'text-red-700',     dot: 'bg-red-600' },
};

export const getStatusStyle = (s) => STATUS_COLORS[s] || STATUS_COLORS.DRAFT;

// Returns shift duration in hours (min 0).
export function shiftDurationHours(shift) {
  const [sh, sm] = (shift.start_time || '0:0').split(':').map(Number);
  const [eh, em] = (shift.end_time || '0:0').split(':').map(Number);
  return Math.max(0, (eh + em / 60) - (sh + sm / 60));
}
